var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _rect, _tspan10, _tspan11, _tspan12, _tspan13, _rect2, _ellipse, _g, _g2, _ellipse2, _path, _path2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegendsSettlement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    width: 400,
    height: 650,
    viewBox: "0 0 105.83 171.98",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title4879"
  }, "legend-settlement") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title4879"
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    fontFamily: "sans-serif",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("text", {
    id: "text186",
    x: 3.1076226,
    y: 15.538118,
    fontSize: "10.583px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan184",
    x: 3.1076226,
    y: 15.538118,
    strokeWidth: 0.26458
  }, "KEY"))), /*#__PURE__*/React.createElement("g", {
    fontSize: "4.2333px"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text190",
    x: 19.165756,
    y: 27.049509,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan188",
    x: 19.165756,
    y: 27.049509,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Enclave Cities of Simeon"))), /*#__PURE__*/React.createElement("text", {
    id: "text194",
    x: 19.165756,
    y: 34.987007,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan192",
    x: 19.165756,
    y: 34.987007,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Enclave Cities of Manasseh"))), /*#__PURE__*/React.createElement("text", {
    id: "text198",
    x: 19.341455,
    y: 42.924507,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan196",
    x: 19.341455,
    y: 42.924507,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Cities of Refuge"))), /*#__PURE__*/React.createElement("text", {
    id: "text202",
    x: 19.165756,
    y: 50.841339,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan200",
    x: 19.165756,
    y: 50.841339,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Location Reasonably Certain"))), /*#__PURE__*/React.createElement("text", {
    id: "text206",
    x: 19.165756,
    y: 58.696156,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan204",
    x: 19.165756,
    y: 58.696156,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Location Less Certain"))), /*#__PURE__*/React.createElement("text", {
    id: "text210",
    x: 19.165756,
    y: 66.598518,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan208",
    x: 19.165756,
    y: 66.598518,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Mountain"))), /*#__PURE__*/React.createElement("text", {
    id: "text214",
    x: 19.165756,
    y: 74.653839,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan212",
    x: 19.165756,
    y: 74.653839,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Precise Location Unknown"))), /*#__PURE__*/React.createElement("text", {
    id: "text218",
    x: 19.165756,
    y: 82.591339,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan216",
    x: 19.165756,
    y: 82.591339,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Road"))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect430",
    x: 0.01731,
    y: 18.646,
    width: 105.81,
    height: 0.88789,
    strokeLinejoin: "bevel",
    strokeWidth: 0.4704
  })), /*#__PURE__*/React.createElement("text", {
    id: "text538",
    x: 7.1262412,
    y: 144.99583,
    fontFamily: "sans-serif",
    fontSize: "4.2333px",
    strokeWidth: 0.26458,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan536",
    x: 7.1262412,
    y: 144.99583
  }, "Alternative location names from same")), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan540",
    x: 7.1262412,
    y: 150.28749
  }, "time period are separated by a comma"))), /*#__PURE__*/React.createElement("text", {
    id: "text538-4",
    x: 7.6297212,
    y: 162.05005,
    fontFamily: "sans-serif",
    fontSize: "4.2333px",
    strokeWidth: 0.26458,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan540-5",
    x: 7.6297212,
    y: 162.05005
  }, "Alternative location names from different")), _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan576",
    x: 7.6297212,
    y: 167.34171
  }, "time periods are in parentheses"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "rect430-7",
    x: -0.075882,
    y: 170.76,
    width: 105.81,
    height: 0.88789,
    strokeLinejoin: "bevel",
    strokeWidth: 0.4704
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "circle602",
    cx: 14.817,
    cy: 49.213,
    rx: 1.3891,
    ry: 1.3891,
    stroke: "#000000",
    strokeWidth: 0.39688
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.39688
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle751",
    cx: 14.817,
    cy: 25.4,
    rx: 1.3891,
    ry: 1.3891,
    fill: "#00a94f",
    stroke: "#00a94f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "circle900",
    cx: 14.817,
    cy: 33.338,
    rx: 1.3891,
    ry: 1.3891,
    fill: "#9d31bd",
    stroke: "#9d31bd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "circle1049",
    cx: 14.817,
    cy: 41.275,
    rx: 1.3891,
    ry: 1.3891,
    fill: "#e6082d",
    stroke: "#e6082d"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g1198",
    transform: "matrix(.69377 0 0 .69377 12.5 71.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1196",
    d: "m2.446 3.7472q-.027905-.080615-.049609-.20774-.021704-.13022-.021704-.25735 0-.19844.077515-.35657.080615-.16123.19844-.30076.11782-.13953.25735-.26665.13953-.13022.25735-.26045.11782-.13333.19534-.27595.080615-.14573.080615-.31936 0-.14883-.058911-.26355-.05581-.11472-.15503-.19224-.099219-.077515-.22944-.11472-.13022-.040308-.27595-.040308-.524 0-.90847.41238v-.5457q.47439-.29766.98289-.29766.23564 0 .44338.062012.20774.062012.36277.18604.15813.12092.24805.30386.089917.18293.089917.42478 0 .22944-.080615.40928-.080616.17983-.20464.33176-.12092.14883-.26355.27905-.14263.13022-.26665.26045-.12092.12712-.20154.26665-.080615.13953-.080615.30696 0 .14263.034106.26045.034107.11472.068213.19534zm.27905 1.2898q-.13643 0-.24185-.099219-.10232-.099219-.10232-.24185 0-.14573.10232-.24185.10232-.10232.24185-.10232t.24185.10232q.10232.096118.10232.24185 0 .14263-.10232.24185-.10542.099219-.24185.099219z",
    fill: "#000000"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "circle1352",
    cx: 14.817,
    cy: 57.15,
    rx: 1.3891,
    ry: 1.3891,
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 0.39688
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1550",
    d: "m15.105 63.5c-.0866 0-.11545.05773-.17318.11545l-1.6741 2.742c-.02886.02887-.02886.08659-.02886.11545 0 .14432.11545.20204.20204.20204h3.3482c.11546 0 .20205-.05773.20205-.20204 0-.05773 0-.05773-.02886-.11545l-1.6452-2.742c-.05773-.05773-.11545-.11545-.20204-.11545zm0 .43296.9525 1.5875h-.23091l-.43296-.43296-.28864.43296-.28864-.43296-.43295.43296h-.25977z",
    fill: "#826539",
    strokeWidth: 0.28864
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1936-6",
    className: "UnoptimicedTransforms",
    transform: "matrix(-.0635 0 0 -.064384 19.201 84.693)",
    d: "m77.392 69.265s-15.035-16.417-25.007-16.417c-9.9713-1e-6-25.007 16.417-25.007 16.417v-22.66s15.561-13.328 25.007-13.328c9.4456 0 25.007 13.328 25.007 13.328zm-.02723-22.662s15.035 16.417 25.007 16.417c9.9713 1e-6 25.007-16.417 25.007-16.417v22.66s-15.561 13.328-25.007 13.328c-9.4455 0-25.007-13.328-25.007-13.328z",
    fill: "#a05a2c",
    strokeLinejoin: "bevel",
    strokeWidth: 0.98452
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g2302",
    transform: "translate(-10.825 2.7794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2130",
    transform: "translate(18.537 95.808)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle2128",
    cx: 2.7722,
    cy: 2.7485,
    r: 2.6458,
    fill: "#008080",
    fillRule: "evenodd",
    strokeWidth: 0.093999
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2134",
    transform: "translate(18.537 95.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2132",
    d: "m3.0583 4.4227h-.43408v-2.7661q-.15675.14952-.41238.29903-.25321.14952-.45579.22428v-.41961q.36415-.17122.63665-.41479t.38585-.47267h.27974z",
    fill: "#ffffff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g2738",
    transform: "translate(7.7125 107.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2605"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle2603",
    cx: 2.7722,
    cy: 2.7485,
    r: 2.6458,
    fill: "#008080",
    fillRule: "evenodd",
    strokeWidth: 0.093999
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2607",
    d: "m3.8386 3.9161v.4172h-2.3368q-.0048231-.15675.050643-.30145.089228-.23875.28456-.47026.19775-.23151.56913-.53537.57636-.47267.77894-.74759.20257-.27733.20257-.52331 0-.25804-.18569-.43408-.18328-.17846-.4799-.17846-.3135 0-.50161.1881-.1881.1881-.19051.5209l-.44614-.04582q.04582-.49919.34485-.75964.29903-.26286.80305-.26286.50884 0 .80546.28215.29662.28215.29662.69935 0 .21222-.086816.4172-.086817.20498-.28939.43167-.20016.22669-.668.62218-.39067.32797-.50161.44614-.11093.11576-.18328.23392z",
    fill: "#ffffff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g2919",
    transform: "translate(7.7125 117.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2784"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle2782",
    cx: 2.7722,
    cy: 2.7485,
    r: 2.6458,
    fill: "#008080",
    fillRule: "evenodd",
    strokeWidth: 0.093999
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2786",
    d: "m1.6267 3.4224.43408-.057878q.074759.36897.25321.53296.18087.16158.43891.16158.30627 0 .51608-.21222.21222-.21222.21222-.52572 0-.29903-.19534-.49196-.19534-.19534-.49678-.19534-.12299 0-.30627.048231l.048231-.38103q.043408.00482.069935.00482.27733 0 .49919-.14469.22186-.14469.22186-.44614 0-.23875-.16158-.3955-.16158-.15675-.4172-.15675-.25321 0-.42202.15916-.16881.15917-.21704.47749l-.43408-.07717q.079582-.43649.36174-.67524.28215-.24116.70177-.24116.28939 0 .53296.1254.24357.12299.37138.33762.13022.21463.13022.45579 0 .2291-.12299.4172-.12299.1881-.36415.29903.3135.072347.48714.30145.17363.22669.17363.56913 0 .46302-.33762.78617-.33762.32074-.85369.32074-.46543 0-.77411-.27733-.30627-.27733-.34968-.71865z",
    fill: "#ffffff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g3098",
    transform: "translate(7.7125 126.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2965"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle2963",
    cx: 2.7722,
    cy: 2.7485,
    r: 2.6458,
    fill: "#008080",
    fillRule: "evenodd",
    strokeWidth: 0.093999
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2967",
    d: "m2.9488 4.311v-.84646h-1.5338v-.39791l1.6133-2.291h.3545v2.291h.47749v.39791h-.47749v.84646zm0-1.2444v-1.594l-1.1069 1.594z",
    fill: "#ffffff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g3277",
    transform: "translate(37.875 98.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3144"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle3142",
    cx: 2.7722,
    cy: 2.7485,
    r: 2.6458,
    fill: "#008080",
    fillRule: "evenodd",
    strokeWidth: 0.093999
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3146",
    d: "m1.5796 3.4743.45579-.038585q.050643.3328.23392.50161.18569.1664.44614.1664.3135 0 .53054-.23633.21704-.23633.21704-.62701 0-.37138-.20981-.58601-.20739-.21463-.54501-.21463-.20981 0-.37862.096463-.16881.094051-.26527.24598l-.40755-.053055.34244-1.8159h1.758v.41479h-1.4108l-.19051.95016q.31833-.22186.668-.22186.46302 0 .78135.32074.31833.32074.31833.82476 0 .4799-.27974.82958-.34003.42926-.92845.42926-.48231 0-.78858-.2701-.30386-.2701-.34727-.71624z",
    fill: "#ffffff"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g3456",
    transform: "translate(37.875 107.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3323"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle3321",
    cx: 2.7722,
    cy: 2.7485,
    r: 2.6458,
    fill: "#008080",
    fillRule: "evenodd",
    strokeWidth: 0.093999
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3325",
    d: "m3.832 1.6861-.43167.033762q-.057878-.25563-.16399-.37138-.17604-.18569-.43408-.18569-.20739 0-.36415.11576-.20498.14952-.32315.43649t-.12299.81752q.15675-.23875.38344-.3545.22669-.11576.47508-.11576.43408 0 .73794.32074.30627.31833.30627.82476 0 .3328-.14469.61977-.14228.28456-.39309.43649-.2508.15193-.56913.15193-.5426 0-.88505-.39791-.34244-.40032-.34244-1.3167 0-1.0249.37862-1.4903.33038-.40514.88987-.40514.4172 0 .68247.23392.26768.23392.32074.6463zm-1.7725 1.5241q0 .22428.094051.42926.096463.20498.26768.3135.17122.10611.35932.10611.27492 0 .47267-.22186t.19775-.60289q0-.36656-.19534-.57636-.19534-.21222-.49196-.21222-.29421 0-.49919.21222-.20498.20981-.20498.55225z",
    fill: "#ffffff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g3635",
    transform: "translate(37.875 117.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3502"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle3500",
    cx: 2.7722,
    cy: 2.7485,
    r: 2.6458,
    fill: "#008080",
    fillRule: "evenodd",
    strokeWidth: 0.093999
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3504",
    d: "m1.6532 1.395v-.4172h2.2886v.33762q-.33762.35932-.67042.95498-.33038.59566-.51125 1.2251-.13022.44373-.1664.97186h-.44614q.0072347-.4172.16399-1.008.15675-.59083.44855-1.1383.29421-.54984.6246-.92604z",
    fill: "#ffffff"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g3814",
    transform: "translate(37.875 126.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3681"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle3679",
    cx: 2.7722,
    cy: 2.7485,
    r: 2.6458,
    fill: "#008080",
    fillRule: "evenodd",
    strokeWidth: 0.093999
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3683",
    d: "m2.2476 2.4385q-.2701-.098874-.40032-.28215-.13022-.18328-.13022-.43891 0-.38585.27733-.64871.27733-.26286.73794-.26286.46302 0 .74517.2701.28215.26768.28215.65353 0 .24598-.13022.42926-.12781.18087-.39067.27974.32556.10611.49437.34244.17122.23633.17122.56431 0 .45337-.32074.76206-.32074.30868-.84405.30868-.52331 0-.84405-.30868-.32074-.31109-.32074-.77411 0-.34485.17363-.57636.17604-.23392.49919-.31833zm-.086816-.73553q0 .2508.16158.40997.16158.15916.41961.15916.2508 0 .40997-.15675.16158-.15916.16158-.38826 0-.23875-.1664-.40032-.16399-.16399-.40997-.16399-.24839 0-.41238.15916-.16399.15916-.16399.38103zm-.13987 1.6326q0 .18569.086816.35932.089228.17363.26286.2701.17363.094051.37379.094051.31109 0 .51366-.20016.20257-.20016.20257-.50884 0-.3135-.20981-.51849-.20739-.20498-.5209-.20498-.30627 0-.50884.20257-.20016.20257-.20016.50643z",
    fill: "#ffffff"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g3993",
    transform: "translate(71.212 98.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3860"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle3858",
    cx: 2.7722,
    cy: 2.7485,
    r: 2.6458,
    fill: "#008080",
    fillRule: "evenodd",
    strokeWidth: 0.093999
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3862",
    d: "m1.7117 3.5828.4172-.038585q.053054.29421.20257.42685.14952.13264.38344.13264.20016 0 .34968-.09164.15193-.09164.24839-.24357.096463-.15434.16158-.41479.065112-.26045.065112-.53054 0-.028939-.00241-.086816-.13022.20739-.35691.33762-.22428.12781-.48714.12781-.43891 0-.74276-.31833-.30386-.31833-.30386-.83923 0-.53778.31592-.86575.31833-.32797.79582-.32797.34485 0 .62942.18569.28698.18569.43408.53054.14952.34244.14952.99357 0 .67765-.14711 1.0804-.14711.40032-.43891.61013-.28939.20981-.68006.20981-.41479 0-.67765-.2291-.26286-.23151-.31592-.64871zm1.7773-1.5603q0-.37379-.20016-.59325-.19775-.21945-.47749-.21945-.28939 0-.50402.23633-.21463.23633-.21463.61254 0 .33762.20257.54984.20498.20981.50402.20981.30145 0 .49437-.20981.19534-.21222.19534-.58601z",
    fill: "#ffffff"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g4188",
    transform: "translate(71.212 107.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4039"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle4037",
    cx: 2.7722,
    cy: 2.7485,
    r: 2.6458,
    fill: "#008080",
    fillRule: "evenodd",
    strokeWidth: 0.093999
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4045",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4041",
    d: "m1.9414 4.3557h-.43408v-2.7661q-.15675.14952-.41238.29903-.25321.14952-.45579.22428v-.41961q.36415-.17122.63665-.41479.27251-.24357.38585-.47267h.27974z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4043",
    d: "m2.6287 2.6121q0-.62701.12781-1.008.13022-.38344.38344-.59083.25563-.20739.64148-.20739.28456 0 .49919.11576.21463.11334.3545.33038.13987.21463.21945.52572.079582.30868.079582.8344 0 .62218-.12781 1.0056-.12781.38103-.38344.59083-.25321.20739-.64148.20739-.51125 0-.80305-.36656-.34968-.44132-.34968-1.4373zm.44614 0q0 .87058.20257 1.16.20498.28698.50402.28698.29903 0 .50161-.28939.20498-.28939.20498-1.1576 0-.87299-.20498-1.16-.20257-.28698-.50643-.28698-.29903 0-.47749.25321-.22428.32315-.22428 1.1937z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g4375",
    transform: "translate(71.212 117.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4239"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle4237",
    cx: 2.7722,
    cy: 2.7485,
    r: 2.6458,
    fill: "#008080",
    fillRule: "evenodd",
    strokeWidth: 0.093999
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4245",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4241",
    d: "m1.9861 4.4674h-.43408v-2.7661q-.15675.14952-.41238.29903-.25321.14952-.45579.22428v-.41961q.36415-.17122.63665-.41479.27251-.24357.38585-.47267h.27974z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4243",
    d: "m4.3663 4.4674h-.43408v-2.7661q-.15675.14952-.41238.29903-.25321.14952-.45579.22428v-.41961q.36415-.17122.63665-.41479t.38585-.47267h.27974z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g4562",
    transform: "translate(71.212 126.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4426"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle4424",
    cx: 2.7722,
    cy: 2.7485,
    r: 2.6458,
    fill: "#008080",
    fillRule: "evenodd",
    strokeWidth: 0.093999
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4432",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4428",
    d: "m1.8297 4.3333h-.43408v-2.7661q-.15675.14952-.41238.29903-.25321.14952-.45579.22428v-.41961q.36415-.17122.63665-.41479.27251-.24357.38585-.47267h.27974z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4430",
    d: "m4.7537 3.9161v.4172h-2.3368q-.0048232-.15675.050643-.30145.089228-.23875.28456-.47026.19775-.23151.56913-.53537.57636-.47267.77894-.74759.20257-.27733.20257-.52331 0-.25804-.18569-.43408-.18328-.17846-.4799-.17846-.3135 0-.50161.1881-.1881.1881-.19051.5209l-.44614-.04582q.04582-.49919.34485-.75964.29903-.26286.80305-.26286.50884 0 .80546.28215.29662.28215.29662.69935 0 .21222-.086816.4172-.086817.20498-.28939.43167-.20016.22669-.668.62218-.39067.32797-.50161.44614-.11093.11576-.18328.23392z"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fontFamily: "sans-serif"
  }, /*#__PURE__*/React.createElement("g", {
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("text", {
    id: "text214-1",
    x: 15.538613,
    y: 102.749,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan212-4",
    x: 15.538613,
    y: 102.749,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Othniel"))), /*#__PURE__*/React.createElement("text", {
    id: "text214-1-2",
    x: 15.362915,
    y: 112.00941,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan212-4-5",
    x: 15.362915,
    y: 112.00941,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Ehud"))), /*#__PURE__*/React.createElement("text", {
    id: "text214-1-3",
    x: 15.499339,
    y: 121.26981,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan212-4-1",
    x: 15.499339,
    y: 121.26981,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Shamgar"))), /*#__PURE__*/React.createElement("text", {
    id: "text214-1-3-9",
    x: 15.362915,
    y: 130.53021,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan212-4-1-5",
    x: 15.362915,
    y: 130.53021,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Barak"))), /*#__PURE__*/React.createElement("text", {
    id: "text214-1-3-0",
    x: 45.701115,
    y: 102.749,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan212-4-1-0",
    x: 45.701115,
    y: 102.749,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Gideon"))), /*#__PURE__*/React.createElement("text", {
    id: "text214-1-3-5",
    x: 45.938824,
    y: 112.00941,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan212-4-1-9",
    x: 45.938824,
    y: 112.00941,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Tola")))), /*#__PURE__*/React.createElement("text", {
    id: "text4743",
    transform: "scale(.26458)",
    fontSize: "40px",
    style: {
      lineHeight: 1.25,
      shapeInside: "url(#rect4745)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("g", {
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("text", {
    id: "text214-1-3-0-8",
    x: 45.847874,
    y: 121.15203,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan212-4-1-0-7",
    x: 45.847874,
    y: 121.15203,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Jair"))), /*#__PURE__*/React.createElement("text", {
    id: "text214-1-3-0-8-3",
    x: 45.847874,
    y: 130.53021,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan212-4-1-0-7-0",
    x: 45.847874,
    y: 130.53021,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Jephthah"))), /*#__PURE__*/React.createElement("text", {
    id: "text214-1-3-0-8-8",
    x: 78.993134,
    y: 102.749,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan212-4-1-0-7-5",
    x: 78.993134,
    y: 102.749,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Ibzan"))), /*#__PURE__*/React.createElement("text", {
    id: "text214-1-3-0-8-2",
    x: 78.862915,
    y: 112.00941,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan212-4-1-0-7-2",
    x: 78.862915,
    y: 112.00941,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Elon"))), /*#__PURE__*/React.createElement("text", {
    id: "text214-1-3-0-8-9",
    x: 79.22258,
    y: 121.26981,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan212-4-1-0-7-6",
    x: 79.22258,
    y: 121.26981,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Abdon"))), /*#__PURE__*/React.createElement("text", {
    id: "text214-1-3-0-8-4",
    x: 78.999336,
    y: 130.44753,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan212-4-1-0-7-1",
    x: 78.999336,
    y: 130.44753,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Samson"))))), /*#__PURE__*/React.createElement("text", {
    id: "text4875",
    x: 8.3591871,
    y: 92.659363,
    fill: "#d40000",
    fontFamily: "sans-serif",
    fontSize: "4.9389px",
    strokeWidth: 0.26458,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan4873",
    x: 8.3591871,
    y: 92.659363,
    fill: "#d40000",
    fontSize: "4.9389px",
    strokeWidth: 0.26458
  }, "Judges:")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendsSettlement);
export default __webpack_public_path__ + "static/media/legends-settlement.c15d37838c694d493e40582b73cb5f4d.svg";
export { ForwardRef as ReactComponent };